import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TNIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TN" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M8 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
          clipRule="evenodd"
        />
        <Path
          fill="#E31D1C"
          d="M5.279 5.987c0-2.708 2.55-3.226 3.422-2.888 0 0-2.108.624-2.108 2.887 0 2.264 2.109 2.839 2.109 2.839-.8.357-3.423-.13-3.423-2.838Zm3.955-.702.956-.322-.49.958.813.663-1.127-.08-.684.818-.038-1.052-1.124-.394 1.045-.382-.013-1.037.662.828Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
